var _defs, _rect, _text, _text2, _g, _path, _g2, _g3, _text3, _text4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2592 1296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#006838;}.cls-3,.cls-4{font-size:331.18px;}.cls-3{fill:#fff;font-family:Noah-Regular, Noah;letter-spacing:0.1em;}.cls-4{fill:#ed1c24;font-family:Lato-Regular, Lato;letter-spacing:0.1em;}.cls-5{clip-path:url(#clip-path);}.cls-6{fill:#046937;}.cls-7{clip-path:url(#clip-path-2);}.cls-8{clip-path:url(#clip-path-3);}.cls-9{fill:#e53125;}.cls-10{font-size:59px;letter-spacing:0.1em;}.cls-10,.cls-11{fill:#231f20;font-family:Noah-Bold, Noah;font-weight:700;}.cls-11{font-size:73px;letter-spacing:0.05em;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1330.89,
    y: 547,
    width: 324.38,
    height: 391.48
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1238.67,
    y: 277.93,
    width: 257.25,
    height: 503.35
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1495.43,
    y: 277.93,
    width: 250.3,
    height: 503.35
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 188.95,
    y: 481.51,
    width: 825.27,
    height: 463.37
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(213.4 818.69)"
  }, "VAN")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(1053.77 823.83)"
  }, /*#__PURE__*/React.createElement("tspan", {
    xmlSpace: "preserve"
  }, "G   ARD"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1600.69,835.3l-106.92,80.43L1388.24,835.3l-36.87-238.49,142.36-31.21,141.21,31.21Zm-107-288.23-162.86,35.71,40.58,262.48,122.24,93.17,123.85-93.17,37.7-262.48-161.51-35.71"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1389.29,647.36,1410.8,828l-1.23-2.07,81.3,66L1405.69,831l-1-.7-.24-1.37-38.68-220,23.5,38.45"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1749.06,387.19c-12-61.06-94.19-109.27-94.19-109.27s85.9,81.39,60.28,159.76c0,0,2.26-23.36-.76-39.19,0,0-15.07,75.36-143.91,91.18,0,0,29.76-6.78,52.93-18.84,0,0-44.65,11.31-66.5,9.05s-40.75-19.56-61.78-4.53c-21-15-39.94,2.27-61.79,4.53s-66.49-9.05-66.49-9.05c23.16,12.06,52.93,18.84,52.93,18.84-128.85-15.82-143.92-91.18-143.92-91.18-3,15.83-.76,39.19-.76,39.19-25.61-78.37,60.28-159.76,60.28-159.76s-82.22,48.21-94.18,109.27c-10.86,55.42,13.25,87.83,73.09,125.84,52.34,33.25,68.57,66.31,68.57,66.31-6-35.42,9-68.57,9-68.57s-12.81,85.91,11.3,113,25.62,47.48,25.62,47.48c6.78-19.6-6-47.48-6-47.48,23.36,36.17,6,88.92,12.06,104.75s14.44,13.17,24.86,2.26c5-5.27,11-18,18.84-6.78s-39.59,17.56-32.06,30.37,48.64,26.9,48.64,26.9,41.09-14.09,48.63-26.9-39.82-19.23-32-30.37,13.79,1.51,18.83,6.78c10.42,10.91,18.84,13.56,24.87-2.26s-11.31-68.58,12-104.75c0,0-12.81,27.88-6,47.48,0,0,1.51-20.35,25.62-47.48s11.31-113,11.31-113,15.07,33.15,9,68.57c0,0,16.22-33.06,68.57-66.31,59.83-38,84-70.42,73.09-125.84"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1743.2,387.19c-12-61.06-94.18-109.27-94.18-109.27s85.9,81.39,60.28,159.76c0,0,2.26-23.36-.76-39.19,0,0-15.07,75.36-143.92,91.18,0,0,29.77-6.78,52.94-18.84,0,0-44.64,11.31-66.5,9.05s-40.75-19.56-61.78-4.53c-21-15-39.94,2.27-61.79,4.53s-66.5-9.05-66.5-9.05c23.17,12.06,52.93,18.84,52.93,18.84C1285.08,473.85,1270,398.49,1270,398.49c-3,15.83-.76,39.19-.76,39.19-25.62-78.37,60.28-159.76,60.28-159.76s-82.22,48.21-94.19,109.27c-10.85,55.42,13.26,87.83,73.1,125.84,52.34,33.25,68.56,66.31,68.56,66.31-6-35.42,9-68.57,9-68.57s-12.82,85.91,11.3,113S1423,671.28,1423,671.28c6.78-19.6-6-47.48-6-47.48,23.36,36.17,6,88.92,12.06,104.75s14.44,13.17,24.86,2.26c5-5.27,11-18,18.84-6.78s-39.59,17.56-32,30.37,48.63,26.9,48.63,26.9,41.09-14.09,48.63-26.9-39.82-19.23-32.06-30.37,13.8,1.51,18.84,6.78c10.42,10.91,18.84,13.56,24.87-2.26s-11.31-68.58,12-104.75c0,0-12.81,27.88-6,47.48,0,0,1.51-20.35,25.62-47.48s11.31-113,11.31-113,15.06,33.15,9,68.57c0,0,16.22-33.06,68.57-66.31,59.83-38,83.94-70.42,73.08-125.84"
  }))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(188.95 455.39)"
  }, /*#__PURE__*/React.createElement("tspan", {
    xmlSpace: "preserve"
  }, "INVEST  GROW  PROSPER"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(1023.11 1014.44)"
  }, "INVESTMENT MANAGEMENT PVT.LTD.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogo);
export default __webpack_public_path__ + "static/media/company-logo.9d4512a5f86162983bcbfede23e9b1b1.svg";
export { ForwardRef as ReactComponent };